import React from 'react';
import { AddDesign } from './AddDesign';
import { designService } from '../services/designService';
import { showSuccessMessage, showApiError } from '@/lib/toast';

export const DesignerUpload = ({ isOpen, onClose, lead }) => {
  if (!lead) return null;

  return (
    <AddDesign
      isOpen={isOpen}
      onClose={onClose}
      initialData={lead}
      targetStatus="initial_design"
      onSubmit={async (formDataArray, sendReview, seniorDesignerId) => {
        try {
          if (formDataArray && formDataArray.length > 0) {
            if (sendReview) {
              formDataArray.forEach(fd => fd.append("sendReview", "true"));
            }
            await Promise.all(formDataArray.map(fd => designService.uploadMedia(fd)));

            if (sendReview && seniorDesignerId) {
              await designService.update(lead._id, {
                siteExecutive: seniorDesignerId,
                mainDesignerApprovalStatus: 'Pending'
              });
            }

            showSuccessMessage(sendReview ? "Design files uploaded and sent for review!" : "Design files uploaded successfully!");
          } else {
            showSuccessMessage("No files to upload.");
          }
          onClose();
        } catch (err) {
          showApiError(err);
        }
      }}
    />
  );
};
